import script from "./ConfirmScoringModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmScoringModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmScoringModal.vue?vue&type=style&index=0&id=703ba406&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-703ba406"]])

export default __exports__